<template>
    <div>
        <Card>
            <Spin v-if="innerSpin"
                size="large"
                fix></Spin>
            <transition name="fade">
                <Row v-if="mainTable.sarchCardShow"
                    :gutter="16">
                    <Col span="24">
                    <search-card :form="mainTable.searchForm"
                        :table-load-event="getPromotionTableRecords"
                        :table-search="mainTable.tableSearch"
                        :colSpan="4" />
                    </Col>
                </Row>
            </transition>

            <Row :gutter="16">
                <Col span="24">
                <div class="global-tool-bar">
                    <div class="left-bar">
                        <span class="title">商品优惠管理</span>
                    </div>
                    <div class="right-bar">
                        <div v-if="$checkAccessArray(['B'])">
						<Button class="btns"
						    size="small"
						    shape="circle"
						    icon="md-arrow-down"
						    @click="onExport">导出</Button>
						<Button class="btns"
						    size="small"
						    shape="circle"
						    type="success"
						    icon="ios-add-circle-outline"
						    @click="onCreate">新增</Button>
                        <Button class="btns"
                            size="small"
                            shape="circle"
                            type="warning"
                            icon="ios-add-circle-outline"
                            @click="onBatchCreate">批量新增</Button>
                        <Button class="btns"
                            size="small"
                            shape="circle"
                            type="info"
                            @click="onActive(1)">启用</Button>
                        <Button class="btns"
                            size="small"
                            shape="circle"
                            type="error"
                            @click="onActive(0)">停用</Button>
                        <Button class="btns"
                            size="small"
                            shape="circle"
                            type="info"
                            ghost
                            @click="onPublic(1)">公开</Button>
                        <Button class="btns"
                            size="small"
                            shape="circle"
                            type="error"
                            ghost
                            @click="onPublic(0)">不公开</Button>
                       </div>
					   <div>
						<Button type="primary"
                            size="small"
                            class="btns"
                            shape="circle"
                            icon="ios-search"
                            @click="mainTable.sarchCardShow = !mainTable.sarchCardShow">搜索</Button>
						</div>
                    </div>
                </div>
                </Col>
            </Row>

            <Row :gutter="16">
                <Col span="24">
                <stand-pagination-table ref="promotionTable"
                    :columns="mainTable.columns"
                    :data="mainTable.data"
                    :loading="mainTable.loading"
                    :table-search="mainTable.tableSearch"
                    :table-load-event="getPromotionTableRecords" />
                </Col>
            </Row>
        </Card>

        <Modal v-model="promotionForm.show"
            title="商品优惠信息"
            width="600">
            <Form ref="promotionForm"
                :model="promotionForm"
                label-position="top">
                <Row :gutter="16">
                    <Col v-if="promotionForm.type === 'single'"
                        span="24">
                    <FormItem label="商品信息">
                        <Select v-model="promotionForm.promotionProductUuid"
                            filterable>
                            <Option v-for="item in productList"
                                :key="item.productUuid"
                                :value="item.productUuid">{{ item.productCode + '-' + item.productName }}</Option>
                        </Select>
                    </FormItem>
                    </Col>
                    <Col v-else
                        span="24">
                    <FormItem label="商品信息">
                        <Select v-model="promotionForm.promotionProductUuids"
                            filterable
                            multiple>
                            <Option v-for="item in productList"
                                :key="item.productUuid"
                                :value="item.productUuid">{{ item.productCode + '-' + item.productName }}</Option>
                        </Select>
                    </FormItem>
                    </Col>
                    <Col span="12">
                    <FormItem label="是否启用">
                        <RadioGroup v-model="promotionForm.promotionEnable">
                            <Radio :label="1">启用</Radio>
                            <Radio :label="0">停用</Radio>
                        </RadioGroup>
                    </FormItem>
                    </Col>
                    <Col span="12">
                    <FormItem label="是否公开">
                        <RadioGroup v-model="promotionForm.promotionPublic">
                            <Radio :label="1">公开</Radio>
                            <Radio :label="0">不公开</Radio>
                        </RadioGroup>
                    </FormItem>
                    </Col>
                </Row>
                <Row :gutter="16">
                    <Col span="12">
                    <FormItem label="订购量">
                        <InputNumber v-model="promotionForm.promotionQuantityThreshold"
                            :min="0"
                            :active-change="false"
                            style="width:100%"></InputNumber>
                    </FormItem>
                    </Col>
                    <Col span="12">
                    <FormItem label="订购量优惠(元)">
                        <InputNumber v-model="promotionForm.promotionQuantityDisount"
                            :min="0"
                            :active-change="false"
                            style="width:100%"></InputNumber>
                    </FormItem>
                    </Col>
                </Row>
                <Row :gutter="16">
                    <Col span="12">
                    <FormItem label="订购额(元)">
                        <InputNumber v-model="promotionForm.promotionValueThreshold"
                            :min="0"
                            :active-change="false"
                            style="width:100%"></InputNumber>
                    </FormItem>
                    </Col>
                    <Col span="12">
                    <FormItem label="订购额优惠(元)">
                        <InputNumber v-model="promotionForm.promotionValudeDiscount"
                            :min="0"
                            :active-change="false"
                            style="width:100%"></InputNumber>
                    </FormItem>
                    </Col>
                </Row>
                <Row :gutter="16">
                    <Col span="12">
                    <FormItem label="付定金比例(%)">
                        <InputNumber v-model="promotionForm.promotionDepositThreshold"
                            :min="0"
                            :active-change="false"
                            style="width:100%"></InputNumber>
                    </FormItem>
                    </Col>
                    <Col span="12">
                    <FormItem label="付定金优惠(元)">
                        <InputNumber v-model="promotionForm.promotionDepositDiscount"
                            :min="0"
                            :active-change="false"
                            style="width:100%"></InputNumber>
                    </FormItem>
                    </Col>
                </Row>
				<Row :gutter="16">
				    <Col span="12">
				    <FormItem label="提前预订天数(天)">
				        <InputNumber v-model="promotionForm.bookAheadDays"
				            :min="0"
				            :active-change="false"
				            style="width:100%"></InputNumber>
				    </FormItem>
				    </Col>
				    <Col span="12">
				    <FormItem label="预订优惠(元)">
				        <InputNumber v-model="promotionForm.bookDiscount"
				            :min="0"
				            :active-change="false"
				            style="width:100%"></InputNumber>
				    </FormItem>
				    </Col>
				</Row>

            </Form>
            <div slot="footer">
                <Button type="primary"
                    @click="onSave">确认</Button>
                <Button type="error"
                    @click="onCancel">取消</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import SearchCard from '@/components/searchCard/searchCard.vue';
import search from '@/libs/search';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import { getPromotionList, savePromotion, getSeedFarmProductList, batchAddPromotion, batchActivePromotion, batchPublicPromotion } from '@/api/modules/system-management/seedFarm-management';
import { DOWNLOAD_SERVER } from '@/api/modules/files';
export default {
    name: 'PromotionList',
    components: {
        StandPaginationTable,
        SearchCard
    },
    props: {
        readOnly: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            innerSpin: false,
            promotionForm: {
                type: 'single',
                show: false,
                promotionUuid: '',
                promotionProductUuid: '',
                promotionProductUuids: [],
                promotionQuantityThreshold: 0,
                promotionQuantityDisount: 0,
                promotionValueThreshold: 0,
                promotionValudeDiscount: 0,
                promotionDepositThreshold: 20,
                promotionDepositDiscount: 0,
                promotionEnable: 0,
                promotionPublic: 0,
                promotionType:0,
                bookAheadDays: 0,
                bookDiscount: 0
            },
            mainTable: {
                columns: [
                    { type: 'selection', width: 60, align: 'center' },
                    { title: '行号', type: 'index', width: 60, align: 'center' },
                    { title: '种苗场编号', key: 'seedFarmCode', align: 'center', excel: true },
                    { title: '种苗场名称', key: 'seedFarmName', align: 'center', excel: true },
                    { title: '商品编号', key: 'productCode', align: 'center', excel: true },
                    { title: '商品名称', key: 'productName', align: 'center', excel: true },
                    { title: '订购量', key: 'promotionQuantityThreshold', align: 'center', excel: true },
                    { title: '订购量优惠', key: 'promotionQuantityDisount', align: 'center', excel: true },
                    { title: '订购额', key: 'promotionValueThreshold', align: 'center', excel: true },
                    { title: '订购额优惠', key: 'promotionValudeDiscount', align: 'center', excel: true },
                    { title: '付定金比例(%)', key: 'promotionDepositThreshold', align: 'center', excel: true },
                    { title: '付定金优惠', key: 'promotionDepositDiscount', align: 'center', excel: true },
                    { title: '提前预订天数', key: 'bookAheadDays', align: 'center', excel: true },
                    { title: '预订优惠', key: 'bookDiscount', align: 'center', excel: true },
                    {
                        title: '是否启用', key: 'promotionEnable', align: 'center', excel: true,
                        render: (h, params) => {
                            let text = params.row.promotionEnable === 1 ? '是' : '否';
                            let color = params.row.promotionEnable === 1 ? '' : 'red';
                            return h('div', [
                                h('span', {
                                    style: {
                                        color: color
                                    }
                                }, text)
                            ]);
                        }
                    },
                    {
                        title: '是否公开', key: 'promotionPublic', align: 'center', excel: true,
                        render: (h, params) => {
                            let text = params.row.promotionPublic === 1 ? '是' : '否';
                            let color = params.row.promotionPublic === 1 ? '' : 'red';
                            return h('div', [
                                h('span', {
                                    style: {
                                        color: color
                                    }
                                }, text)
                            ]);
                        }
                    },
                    {
                        title: '操作',
                        key: 'action',
                        align: 'center',
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small'
                                    },
                                    style: {},
                                    on: {
                                        click: () => {
                                            this.onPromotionUpdate(params.row);
                                        }
                                    }
                                }, '编辑')]);
                        }
                    }
                ],
                data: [],
                sarchCardShow: false,
                searchForm: [
                    { label: '苗场信息', type: 'Input', value: '', name: 'concat(seedFarmCode, seedFarmName)', sql: 'like' },
                    { label: '商品信息', type: 'Input', value: '', name: 'concat(productCode, seedFarmName)', sql: 'like' },
                    {
                        label: '是否启用',
                        type: 'Select',
                        value: [],
                        name: 'promotionEnable',
                        sql: 'in',
                        options: [{ key: '启用', value: '1' }, { key: '停用', value: 0 }]
                    },
                    {
                        label: '是否公开',
                        type: 'Select',
                        value: [],
                        name: 'promotionPublic',
                        sql: 'in',
                        options: [{ key: '公开', value: '1' }, { key: '不公开', value: 0 }]
                    }
                ],
                loading: false,
                tableSearch: search.getSearchParams()
            },
            productList: []
        };
    },
    mounted() {
        this.getProductList();
        this.getPromotionTableRecords();
    },
    methods: {
        onExport(){
            this.mainTable.tableSearch.excelExport.enable = true;
            this.mainTable.tableSearch.excelExport.columns = this.mainTable.columns
                .filter(col => col.excel)
                .map(col => {
                    return {
                        key: col.key,
                        title: col.title
                    };
                });
            this.mainTable.loading = true;
            getPromotionList(this.mainTable.tableSearch).then(res => {
			    if (res.code === 0) {
			        if (res.code === 0) {
			            let url = DOWNLOAD_SERVER + res.data.exportFileName;
			            this.$downLoadFile(url);
			            // window.open(FILE_SERVER + res.data.exportFileName, "_blank");
			        }
			    }
			    this.mainTable.loading = false;
            }).catch(error => {
                console.error('Export failed:', error);
                this.mainTable.loading = false;
                this.$Modal.error({
                    title: '导出失败',
                    content: '导出过程中发生错误，请重试'
                });
            }).finally(() => {
                // 确保loading状态被重置
                this.mainTable.loading = false;
                // 重置导出配置
                this.mainTable.tableSearch.excelExport.enable = false;
            });
        },
        onPublic(type) {
            let selection = this.$refs.promotionTable.$refs.standPaginationTable.getSelection();
            if (selection.length === 0) {
                this.$Modal.error({
                    title: '未勾选记录'
                });
                return;
            }

            let data = {
                promotionUuids: selection.map(e => {
                    return e.promotionUuid;
                }),
                enable: type
            };
            this.innerSpin = true;
            batchPublicPromotion(data).then(res => {
                this.innerSpin = false;
                if (res.code === 0) {
                    this.getPromotionTableRecords();
                }
            });
        },
        onActive(type) {
            let selection = this.$refs.promotionTable.$refs.standPaginationTable.getSelection();
            if (selection.length === 0) {
                this.$Modal.error({
                    title: '未勾选记录'
                });
                return;
            }

            let data = {
                promotionUuids: selection.map(e => {
                    return e.promotionUuid;
                }),
                enable: type
            };
            this.innerSpin = true;
            batchActivePromotion(data).then(res => {
                this.innerSpin = false;
                if (res.code === 0) {
                    this.getPromotionTableRecords();
                }
            });
        },
        getProductList() {
            getSeedFarmProductList().then(res => {
                if (res.code === 0) {
                    this.productList = res.data.productList;
                }
            });
        },
        getPromotionTableRecords(reset = false) {
            this.mainTable.loading = true;

            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }
            getPromotionList(this.mainTable.tableSearch).then(res => {
                if (res.code === 0) {
                    this.mainTable.data = res.data.records;
                    search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
                }

                this.mainTable.loading = false;
            }).catch(() => {
                this.mainTable.loading = false;
            });
        },
        onBatchCreate() {
            this.promotionForm.type = 'multi';
            this.promotionForm.promotionUuid = '';
            this.promotionForm.promotionProductUuid = '';
            this.promotionForm.promotionQuantityThreshold = 0;
            this.promotionForm.promotionQuantityDisount = 0;
            this.promotionForm.promotionValueThreshold = 0;
            this.promotionForm.promotionValudeDiscount = 0;
            this.promotionForm.promotionDepositThreshold = 20;
            this.promotionForm.promotionDepositDiscount = 0;
            this.promotionForm.promotionEnable = 1;
            this.promotionForm.promotionPublic = 1;
            this.promotionForm.bookAheadDays = 0;
            this.promotionForm.bookDiscount = 0;
            this.promotionForm.show = true;
        },
        onCreate() {
            this.promotionForm.type = 'single';
            this.promotionForm.promotionUuid = '';
            this.promotionForm.promotionProductUuid = '';
            this.promotionForm.promotionQuantityThreshold = 0;
            this.promotionForm.promotionQuantityDisount = 0;
            this.promotionForm.promotionValueThreshold = 0;
            this.promotionForm.promotionValudeDiscount = 0;
            this.promotionForm.promotionDepositThreshold = 20;
            this.promotionForm.promotionDepositDiscount = 0;
            this.promotionForm.promotionEnable = 1;
            this.promotionForm.promotionPublic = 1;
            this.promotionForm.bookAheadDays = 0;
            this.promotionForm.bookDiscount = 0;
            this.promotionForm.show = true;
        },
        onCancel() {
            this.promotionForm.show = false;
        },
        onPromotionUpdate(row) {
            Object.assign(this.promotionForm, row);
            this.promotionForm.show = true;
        },
        onSave() {
            if (this.promotionForm.type === 'single') {
                savePromotion(this.promotionForm).then(res => {
                    if (res.code === 0) {
                        this.$Modal.success({
                            title: '保存成功',
                            onOk: () => {
                                this.promotionForm.show = false;
                                this.getPromotionTableRecords();
                            }
                        });

                    }
                });
            }
            else {
                batchAddPromotion(this.promotionForm).then(res => {
                    if (res.code === 0) {
                        this.$Modal.success({
                            title: '保存成功',
                            onOk: () => {
                                this.promotionForm.show = false;
                                this.getPromotionTableRecords();
                            }
                        });

                    }
                });
            }
        }
    }
};
</script>

<style lang="less" scoped>
.form-button {
    margin-top: 5px;
}
</style>
